import React, { useState} from "react";
import {Link} from "react-router-dom";
import PubProducts from "./pubProduct";
import ProductFollow from "./pubProdFollow";
import { Row } from 'react-bootstrap';
import { elakay_API } from "../../../config";
import {isAuthenticated, addFollowUserShop } from "../../../includes/auth";
import SwiperCatUserProd from "../../slider/swiperUserProd/swiperCatUserProd";


function getShopName(userAccount) {
    // Vérifie s’il existe au moins un shopName valide
    const hasValidShopName = Array.isArray(userAccount)
      && userAccount.some(addr => {
        return addr.shopName !== null
          && addr.shopName !== undefined
          && addr.shopName !== ''
          && addr.shopName !== "''";
      });
    if (hasValidShopName) {
      // Filtre les shopName valides et formate chacun : première lettre majuscule, reste en minuscules
      const validShopNames = userAccount
        .filter(addr => {
          return addr.shopName !== null
            && addr.shopName !== undefined
            && addr.shopName !== ''
            && addr.shopName !== "''";
        })
        .map(addr => {
          const shop = addr.shopName;
          const firstLetter = shop.slice(0, 1).toUpperCase();
          const rest = shop.slice(1).toLowerCase();
          return firstLetter + rest;
        });
  
      return validShopNames;
    } else {
    // Étape 2 : Aucun shopName valide, on renvoie deux lettres (fallback)
  // On cherche l'adresse "par défaut" ou, à défaut, la première adresse
  const defaultAddress = userAccount.find(a => a.addressDefault === true) || userAccount[0];
  const firstName = defaultAddress.firstName ? defaultAddress.firstName.trim() : "";
  const lastName = defaultAddress.lastName ? defaultAddress.lastName.trim() : "";
  
  const first = firstName[0] ? firstName[0].toUpperCase() : "";
  const last = lastName[0] ? lastName[0].toUpperCase() : "";

  return first + last;
    }
  }
  const COLORS = [
    "GhostWhite",        // très pâle
    "Ivory",             // très pâle
    "MintCream",         // très pâle
    "Silver",            // neutre clair
    "White",             // neutre total
    "LightGray",         // clair
    "Gainsboro",         // clair
    "LightSlateGray",    // doux
    "LightSteelBlue",    // pastel bleu
    "AliceBlue",         // bleu très pâle
    "AntiqueWhite",      // beige doux
    "Azure",             // bleu très clair
    "Beige",             // beige doux
    "Bisque",            // pêche pâle
    "BlanchedAlmond",    // beige amande
    "Cornsilk"           // jaune très pâle
  ];
  
    
    const getRandomColor = () =>
      COLORS[Math.floor(Math.random() * COLORS.length)];

const CategoryPub = (props) => {
const { token } = isAuthenticated();
const [shopUser, setShopUser] = useState("seller");
const {
    activeFollowBtn = false,  
    nbrArr = 3,
    Follow = false,
    booFollow = false,
    unFollow = false,
    ci = true,
    inView= false,
    setCi,
    pubCategoryProd, 
    unFollowShop,
    findToFollowU,
    setSearch,
    userID,
    infoSource
 } = props


 const clickToFollowShop = () => {
    addFollowUserShop(token ,userID).then(data => {
        if(!data){
            console.log(data.error)
        }else{
            // infoSource.userInfo && findToFollowU(data.followShopUser, infoSource.userAdmin, data._id) 
            unFollowShop(data.followShopUser)
            infoSource.readUser(token)
        }
    })
}; 

const user_id =(u)=>{
    return u._id._id ? u._id._id: u._id
}

// const productALL0 =(a)=>{
    

//     return <Row className="m-1 p-1 mb-4"  xs={nbrArr}>
//          {
//           pubCategoryProd && pubCategoryProd.map((items, i) => (
//             <div className="p-1" key={i}>
//             <div className="card"> 
//                    <PubProducts
//                 infoSource ={infoSource}
//                 setShopUser={setShopUser}
//                 userID={userID}
//                 categoryID={user_id(items)}
//                 />
//             <h6>{items._id.name && items._id.name[0]} 
//             {
//             inView?
//             <Link onClick={()=>setCi(user_id(items), items._id.name[0] )}>
//             {infoSource.language(infoSource, "Link", "seeMore")}
//             </Link>
//             :
//             <Link to={`/lakay-ShopSeller/${userID}?ci=${user_id(items)}`}>
//             {infoSource.language(infoSource, "Link", "seeMore")}
//             </Link>
//             }
//             </h6>
//             </div>
           
//             </div>
//              ))
//              }
//      </Row>
//  }

 let myStyles = {
    width: "100%",
    backgroundColor: '#f0f0f0'
}

 const productALL =()=>{
    return  <SwiperCatUserProd
            nbrArr={nbrArr}
            title={"shop Categories"}
            pubCategoryProd={pubCategoryProd}
            userID={userID}
            myStyles={myStyles} 
            infoSource ={infoSource}
            setCi={setCi}
            setSearch={setSearch}
            shop={true}
            setShopUser={setShopUser}
            getShopName={getShopName}
            inView={inView}
            />
}
 

const prodFollow = (arr)=>{
  const slides = [];
 arr && arr.map((items, i) => 
  slides.push( <div key={i}>
            <ProductFollow
            infoSource ={infoSource}
            setShopUser={setShopUser}
            getShopName={getShopName}
            userID={userID}
            categoryID={user_id(items)}
            />
        </div>))

const fillers = Math.max(0, nbrArr - arr.length);
for (let f = 0; f < fillers; f += 1) {
  slides.push( <div key={`filler-${f}`}  style={{ aspectRatio: '1',  width: '100%',  backgroundColor: getRandomColor()}} > 
        
  </div>)
}
  return slides
}
const bntFollow = <button  className="m-1 py-3 px-0 btn btn-outline-success rounded-4 shadow-lg" role="button" onClick={()=>clickToFollowShop()}>
    {/* Follow */}
    {infoSource.language(infoSource, "Button", "follow")}
    </button>

const bntUnFollow = <button  className="m-1 py-3 px-0 btn btn-outline-danger rounded-4 shadow-lg" role="button" onClick={()=>clickToFollowShop()}>
    {/* UnFollow */}
    {infoSource.language(infoSource, "Button", "unFollow")}
    </button>


const LinkViewAll =  inView ?
<Link className="m-1 py-3 px-0 btn btn-outline-dark rounded-4 shadow-lg" onClick={()=>{setCi(null); setSearch('')}}>
{/* View All */}
{infoSource.language(infoSource, "title", "viewAll")}
</Link>
: <Link  className="m-1 py-3 px-0 btn btn-outline-dark rounded-4 shadow-lg"  to={`/lakay-ShopSeller/${userID}`} role="button"> 
{/* view lakay  */}
{infoSource.language(infoSource, "Button", "viewLakay")} 
{" "}
{shopUser}</Link>


 const prodFollowALL =()=>{
    
    return <div className="card m-4 p-0">
    <table style={{width: '100%'}}>
        <tr>
            <td className="w-25 p-0">
        <div className="d-grid gap-2 mx-auto">
        {booFollow && unFollow ?
         ci  ? LinkViewAll : activeFollowBtn ? bntFollow : LinkViewAll
        :
        !booFollow? LinkViewAll : !unFollow && ci ? LinkViewAll : bntUnFollow
       }
          </div>
             </td>
            <td>
            <Row className="p-1"  xs={nbrArr}>
            {prodFollow(pubCategoryProd)}
             </Row>
             </td>
             </tr>
           </table>
             </div>
}
 
 return Follow? prodFollowALL() : productALL()
}
export default CategoryPub;